export default __webpack_public_path__ + "static/media/2.0b93e76f.jpg";